module.exports = __webpack_public_path__ + "static/media/pagination-left.bc9034cc.svg";